import { API } from "../../../../utils/api";

export async function getExtraOptionAPI(modelType, period) {
  return (await API.get(`v2/lease/option?modelType=${modelType}&period=${period}`)).data
}